import { render } from "./Historical.vue?vue&type=template&id=4b1e9cc2&scoped=true"
import script from "./Historical.vue?vue&type=script&lang=js"
export * from "./Historical.vue?vue&type=script&lang=js"

import "./Historical.vue?vue&type=style&index=0&id=4b1e9cc2&scoped=true&lang=css"

import exportComponent from "C:\\Users\\User\\Desktop\\SMFBackstageBase\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4b1e9cc2"]])

export default __exports__